var _line, _rect, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFShadeGuideOutsideCeilingHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "422px",
    height: "510px",
    viewBox: "0 0 422 510",
    enableBackground: "new 0 0 422 510",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.9941,
    x1: 0,
    y1: 5.9,
    x2: 389.3,
    y2: 5.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 10.2,
    fill: "#DCDCDC",
    width: 349,
    height: 402
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 104.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 280.1,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 127.6,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.6349,
    x1: 211,
    y1: 487.6,
    x2: 211,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.9,486.2 211,494.7 206.1,486.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.9,18.6 211,10.2 206.1,18.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.638,
    x1: 304,
    y1: 487.6,
    x2: 304,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "308.9,486.2 304,494.7 299.1,486.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "308.9,18.7 304,10.2 299.1,18.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.638,
    x1: 118,
    y1: 487.6,
    x2: 118,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "122.9,486.2 118,494.7 113.1,486.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "122.9,18.7 118,10.2 113.1,18.7  "
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M400.3,6.9c0.1,0,0.2,0,0.4,0c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0s0.3,0,0.4-0.1c-0.1-0.1-0.2-0.2-0.3-0.4 c-0.1-0.1-0.2-0.3-0.2-0.4s-0.1-0.3-0.1-0.4s0-0.3,0-0.5c0-0.3,0.1-0.5,0.2-0.8c0.1-0.2,0.3-0.5,0.5-0.6c0.2-0.2,0.4-0.3,0.7-0.4 s0.5-0.2,0.8-0.2c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.5,0.3,0.6,0.5s0.3,0.4,0.4,0.6s0.1,0.5,0.1,0.7c0,0.3,0,0.6-0.1,0.9 c-0.1,0.3-0.2,0.5-0.5,0.8c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.2,0h0.4v1H406 c-0.5,0-0.9,0-1.3-0.1s-0.8-0.1-1.1-0.2c-0.2,0.1-0.4,0.1-0.7,0.2s-0.6,0.1-0.9,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.3,0-0.6,0-0.9,0 c-0.5,0-0.9,0-1.3,0c-0.4,0-0.8,0-1.2-0.1c-0.4-0.1-0.7-0.2-1-0.3c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.3-0.4-0.3-0.6 c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.2,0-0.4,0-0.6s0.1-0.4,0.1-0.5s0.1-0.3,0.1-0.4c0-0.1,0-0.2,0-0.2l1,0.3c0,0.2-0.1,0.3-0.1,0.4 c0,0.1-0.1,0.3-0.1,0.4c0,0.2,0,0.3,0,0.5c0,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.2,0.7,0.2 c0.3,0.1,0.5,0.1,0.8,0.1c0.3,0,0.6,0,0.9,0C399.7,6.9,400,6.9,400.3,6.9z M402.5,5.1c0,0.2,0,0.3,0.1,0.5s0.1,0.3,0.2,0.4 c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.2,0.5,0.2c0.2-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3s0.2-0.2,0.2-0.4 c0.1-0.1,0.1-0.3,0.1-0.5c0-0.1,0-0.2-0.1-0.4s-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1 c-0.2,0-0.3,0-0.4,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3S402.5,5,402.5,5.1z M402.7,0.9l0.9-0.9l0.9,0.9l-0.9,0.9 L402.7,0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M409.4,3.1c0.3,0,0.6,0.1,0.8,0.2s0.5,0.3,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7 c0,0.4,0,0.7-0.1,1c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.6,0,0.9,0h0.6v1h-0.6c-0.9,0-1.7-0.1-2.3-0.3c-0.3,0.1-0.7,0.2-1.1,0.2 c-0.4,0-0.9,0.1-1.4,0.1h-0.6v-1h0.6c0.4,0,0.8,0,1.1,0c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.6-0.2-0.9c0-0.3,0.1-0.5,0.2-0.8 c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.4-0.3,0.7-0.4C408.9,3.2,409.1,3.1,409.4,3.1z M408.2,1.8l-0.9-0.9l0.9-0.9l0.9,0.9L408.2,1.8z  M409.4,6.5c0.2-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3s0.2-0.2,0.2-0.4s0.1-0.3,0.1-0.5c0-0.1,0-0.2-0.1-0.3 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.2,0,0.3,0.1,0.5s0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.4,0.3 C409.1,6.3,409.2,6.4,409.4,6.5z M410.3,1.8l-0.9-0.9l0.9-0.9l0.9,0.9L410.3,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M416.4,7.8c-0.3,0-0.6,0-0.9-0.2c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2,0.2-0.4,0.4-0.7,0.5s-0.5,0.1-0.8,0.1h-1.2 v-1h1.2c0.1,0,0.1,0,0.2,0s0.2-0.1,0.3-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.6v0V4.1h1v1.6c0,0.4,0.1,0.6,0.2,0.8 c0.2,0.2,0.4,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.3,0.1-0.6V4.1h1v1.6 c0,0.4,0.1,0.6,0.3,0.8s0.4,0.3,0.8,0.3c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.5 c0-0.1,0-0.2,0-0.3s0-0.2,0-0.4c0-0.1,0-0.3-0.1-0.4s-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3s0-0.2-0.1-0.2l1-0.3c0,0,0,0.1,0,0.2 c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.3,0.1,0.5c0,0.2,0.1,0.3,0.1,0.5s0,0.3,0.1,0.5s0,0.3,0,0.4c0,0.3-0.1,0.6-0.2,0.9 c-0.1,0.3-0.3,0.5-0.4,0.6c-0.2,0.2-0.4,0.3-0.6,0.4c-0.2,0.1-0.5,0.1-0.7,0.1c-0.3,0-0.7-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5 c-0.2,0.2-0.4,0.3-0.7,0.4S416.7,7.8,416.4,7.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFShadeGuideOutsideCeilingHeight);
export default __webpack_public_path__ + "static/media/FShadeGuide-Outside-Ceiling-Height-٠١.052d6ca5abd58923a97eaf0b277a38e4.svg";
export { ForwardRef as ReactComponent };